import api from '@/api';
import {
  AlertListResponse,
  ChatMessageResponse,
  ChatListResponse,
  EditedListPerRefundResponse,
  MessageAlertResponse,
  NotificationResponse,
  SendChatRequest,
  SendChatResponse,
} from '@/types/cs.type';

export const getAlertList = async () => {
  const res = await api.getAxios('/user/refund/requirement');
  return res.data as AlertListResponse;
};

export const readNewAlert = async ({
  requirementId,
}: {
  requirementId: number;
}) => {
  const res = await api.patchAxios(`/user/refund/requirement/${requirementId}`);
  return res.status;
};

export const getEditedListPerRefund = async ({
  refundId,
}: {
  refundId: number;
}) => {
  const res = await api.getAxios(`/user/refund/requirements/${refundId}`);
  return res.data as EditedListPerRefundResponse;
};

// 리뉴얼

export const sendChat = async (payload: SendChatRequest) => {
  const res = await api.postAxios('/user/chat', payload);
  return res.data as SendChatResponse;
};

export const getMessageAlert = async () => {
  const res = await api.getAxios('/user/chat/notification');
  return res.data as MessageAlertResponse;
};

export const getNotificationList = async () => {
  const res = await api.getAxios('/user/chat/notification/list', {});
  return res.data as NotificationResponse;
};

export const getChatList = async () => {
  const res = await api.getAxios('/user/chat');
  return res.data as ChatListResponse;
};

export const getChatMessage = async (chatId: number) => {
  const res = await api.getAxios(`/user/chat/${chatId}`);
  return res.data as ChatMessageResponse;
};

export const readAlert = async (payload: {
  chatId: number;
  notificationType: 'ONE_ON_ONE' | 'REQUIREMENT_RESULT' | 'ADMIN_NOTICE';
}) => {
  const res = await api.patchAxios(`/user/chat/notification`, payload);
  return res.status;
};
